import { render, staticRenderFns } from "./DownloadArticles.vue?vue&type=template&id=1fa610b6&scoped=true"
import script from "./DownloadArticles.vue?vue&type=script&lang=js"
export * from "./DownloadArticles.vue?vue&type=script&lang=js"
import style0 from "./DownloadArticles.vue?vue&type=style&index=0&id=1fa610b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa610b6",
  null
  
)

export default component.exports